import { z } from '@qred/components-library';
import {
  validateEmail,
  validatePhoneNumber,
} from '@qred/shared-component-library/src/validators';
import { CountryCode } from '~/enums';
import { requiredString } from '~/helpers/schema.helper';
import { companySearchSchema } from './components/CompanySearch';

export const createStartApplicationSchema = (market: CountryCode) => {
  return z.object({
    ...companySearchSchema.shape,
    phone: requiredString({
      validator: (value) => validatePhoneNumber(value, market),
      message: 'ValidationErrors.Phone',
    }),
    email: requiredString({
      validator: (value) => validateEmail(value),
      message: 'ValidationErrors.Email',
    }),
  });
};

export type StartApplicationForm = z.infer<
  ReturnType<typeof createStartApplicationSchema>
>;
